import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    mutation updateUserProfile ($id: ID!, $input: UserUpdate!) {
      UserProfile: updateUser (id: $id, input: $input) {
        ...userProfileBig
      }
    }
    ${fragments.userProfileBig}
    ${fragments.userProfileDetail}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.companyDetail}
    ${fragments.companyArtworks}
    ${fragments.companyNameDetail}
    ${fragments.companyNames}
  `
